<template>
  <div class="zigzag" :style="dividerStyles"></div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import THEME from "../../constants/theme"
export default defineComponent({
  name: "DividerZigZag",
  props: {
    backgroundColor: {
      type: String,
      default: "white",
    },
    lineColor: {
      type: String,
      default: THEME.colors.light.mediumGrey,
    },
  },
  setup(props) {
    return {
      dividerStyles: {
        "--backgroundColor": props.backgroundColor,
        "--lineColor": props.lineColor,
      },
    }
  },
})
</script>

<style lang="sass" scoped>
$backgroundcolor: var(--backgroundColor)
$height: 16px
$halfheight: ($height/2)
$thickness: 2px
$offset: 4px
$linecolor: var(--lineColor)

.zigzag
  margin: 4px 0
  background: $backgroundcolor
  position: relative
  height: $height
  z-index: 1
  &:before,
  &:after
    content: ""
    display: block
    position: absolute
    left: 0
    right: 0

  &:before
    height: ($height - $offset)
    top: $thickness
    background: linear-gradient(-135deg, $linecolor $halfheight, transparent 0) 0 $halfheight, linear-gradient( 135deg, $linecolor $halfheight, transparent 0) 0 $halfheight
    background-position: top left
    background-repeat: repeat-x
    background-size: $height $height

  &:after
    height: $height
    top: 0
    background: linear-gradient(-135deg, $backgroundcolor $halfheight, transparent 0) 0 $halfheight, linear-gradient( 135deg, $backgroundcolor $halfheight, transparent 0) 0 $halfheight
    background-position: top left
    background-repeat: repeat-x
    background-size: $height $height
</style>
